import onlineService from '../services/onlineService';
import { SYNCHRONIZE_LOCAL_DATABASE } from '../store/offline/actions/actionTypes';
import { SET_IS_OFFLINE_STATUS } from '../store/offline/mutations/mutationTypes';

export default {
  data() {
    return {
      connectivityPollInterval: null,
      isProcessingPendingActions: false,
    };
  },
  methods: {
    async handleOnlineConnectivity() {
      console.log(
        '[Connectivity] Browser reported ONLINE. Starting recovery flow.'
      );
      this.$store.commit(SET_IS_OFFLINE_STATUS, false);
      await this.synchronizePendingActions();
    },

    handleOfflineConnectivity() {
      console.log(
        '[Connectivity] Browser reported OFFLINE. Switching to offline mode.'
      );
      this.$store.commit(SET_IS_OFFLINE_STATUS, true);
    },

    async runConnectivityRecoveryTick() {
      const isOnline = await onlineService.getStatus();
      const isOfflineInStore = this.$store.state.OfflineModule.isOfflineMode;

      if (isOnline && isOfflineInStore) {
        console.log(
          '[ConnectivityPoll] Internet restored while app state is offline. Triggering sync.'
        );
        await this.handleOnlineConnectivity();
      } else if (!isOnline && !isOfflineInStore) {
        console.log(
          '[ConnectivityPoll] Internet lost while app state is online. Switching to offline.'
        );
        this.handleOfflineConnectivity();
      }
    },

    async initializeConnectivityRecovery() {
      this.onBrowserOnline = async () => {
        await this.handleOnlineConnectivity();
      };

      this.onBrowserOffline = () => {
        this.handleOfflineConnectivity();
      };

      window.addEventListener('online', this.onBrowserOnline);
      window.addEventListener('offline', this.onBrowserOffline);

      const online = await onlineService.getStatus();
      console.log('[Connectivity] Initial online status check:', online);
      this.$store.commit(SET_IS_OFFLINE_STATUS, !online);

      if (online) {
        console.log(
          '[Connectivity] Online on startup. Checking pending sync records.'
        );
        await this.synchronizePendingActions();
      }

      this.connectivityPollInterval = setInterval(async () => {
        await this.runConnectivityRecoveryTick();
      }, 5000);
    },

    teardownConnectivityRecovery() {
      if (this.connectivityPollInterval) {
        clearInterval(this.connectivityPollInterval);
        this.connectivityPollInterval = null;
      }

      if (this.onBrowserOnline) {
        window.removeEventListener('online', this.onBrowserOnline);
      }

      if (this.onBrowserOffline) {
        window.removeEventListener('offline', this.onBrowserOffline);
      }
    },

    async synchronizePendingActions() {
      if (this.isProcessingPendingActions) {
        console.log('[Sync] Skipping pending-action sync: already running.');
        return;
      }

      console.log('[Sync] Starting pending-action synchronization...');
      this.isProcessingPendingActions = true;
      try {
        await this.$store.dispatch(SYNCHRONIZE_LOCAL_DATABASE, {
          toast: this.$buefy.toast,
        });
        console.log('[Sync] Pending-action synchronization finished.');
      } catch (error) {
        console.error('[Sync] Pending-action synchronization failed.', error);
      } finally {
        this.isProcessingPendingActions = false;
      }
    },
  },
};
